import React, { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import axiosInstance from '../../../services/axiosInterceptors';
import nipponBotApiEndpoints from '../../../services/nipponBotApiEndpoints';

export default function ElevenLabsSyncPanel({ onComplete, onMessage }) {
  const [syncing, setSyncing] = useState(false);
  const token = localStorage.getItem('token');

  const runImport = async () => {
    setSyncing(true);
    try {
      const response = await axiosInstance.post(
        nipponBotApiEndpoints.importElevenLabs,
        { importAll: true },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const results = response?.data?.data?.results || [];
      const importedCount = results.filter((item) => item.status === 'imported').length;
      const requeuedCount = results.filter((item) => item.status === 'requeued').length;
      const failedCount = results.filter((item) => item.status === 'failed').length;
      const skippedCount = results.filter((item) => item.status === 'skipped').length;

      onMessage(
        `Xeny sync finished: ${importedCount} imported, ${requeuedCount} requeued, ${skippedCount} skipped, ${failedCount} failed.`,
        failedCount ? 'warning' : 'success'
      );
      onComplete();
    } catch (error) {
      onMessage(error?.response?.data?.status?.value || error?.response?.data?.message || 'Failed to sync Xeny recordings.', 'error');
    } finally {
      setSyncing(false);
    }
  };

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={syncing ? <CircularProgress size={14} /> : <SyncIcon fontSize="small" />}
      onClick={runImport}
      disabled={syncing}
      sx={{
        textTransform: 'none',
        color: '#7635DD',
        borderColor: '#7635DD',
        fontWeight: 700,
        '&:hover': {
          borderColor: '#7635DD',
          backgroundColor: 'rgba(118,53,221,0.08)',
        },
        '&:disabled': {
          borderColor: '#c4b5e0',
          color: '#9ca3af',
        },
      }}
    >
      {syncing ? 'Syncing...' : 'Sync Xeny Recordings'}
    </Button>
  );
}
